import React, { useState } from 'react'
import styled from 'styled-components'
import Colors from '../../../assets/styles/Colors'
import Responsive from '../../../assets/config/Responsive'
//
//
type optionType = {
  value: any
  label: any
}
//
//
const RadioButton: React.FC<{
  options: optionType[] | []
  defaultOption?: optionType['value']
  size?: 'normal' | 'small'
  onChange?: (_: any) => void
  style?: React.CSSProperties
}> = ({ options, defaultOption, size = 'normal', onChange, style }) => {
  //
  const [selectedOption, setSelectedOption] = useState(defaultOption)

  const handleOptionChange = (event: any) => {
    setSelectedOption(event.target.value)
    //
    onChange?.(event.target.value)
  }
  //
  return (
    <>
      {options.map((option) => (
        <Label key={option.value} $size={size} $active={selectedOption === option.value ? true : false}>
          <Input
            $size={size}
            $active={selectedOption?.toString() === option.value?.toString() ? true : false}
            type="radio"
            value={option.value}
            checked={selectedOption === option.value}
            onChange={handleOptionChange}
          />
          {option.label && (
            <div
              style={{
                fontWeight: selectedOption?.toString() === option.value?.toString() ? 'bold' : 'normal',
                color:
                  selectedOption?.toString() === option.value?.toString() ? Colors.primaryBlack : Colors.nevadaGrey,
              }}
            >
              {option.label}
            </div>
          )}
        </Label>
      ))}
    </>
  )
}
//
const Label = styled.label<{ $active: boolean; $size: 'normal' | 'small' }>`
  display: flex;
  align-items: center;
  cursor: pointer;

  div {
    padding-left: 12px;
    color: ${({ $active }) => ($active === true ? Colors.primaryBlack : Colors.nevadaGrey)};
    font-size: 14px;
  }
`

const Input = styled.input<{ $active: boolean; $size: 'normal' | 'small' }>`
  height: ${({ $size }) => ($size === 'normal' ? '32px' : '20px')};
  width: ${({ $size }) => ($size === 'normal' ? '32px' : '20px')};
  position: relative;
  outline: none;
  border: none;
  appearance: none;

  &::after {
    content: '';
    height: ${({ $size }) => ($size === 'normal' ? '32px' : '20px')};
    width: ${({ $size }) => ($size === 'normal' ? '32px' : '20px')};
    background-color: ${Colors.white};
    display: block;
    outline: none;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    box-shadow: ${({ $active, $size }) =>
      $active === true && $size === 'normal'
        ? `inset 0px 0px 0px 11px ${Colors.primaryRed}`
        : $active === true && $size === 'small'
        ? `inset 0px 0px 0px 7px ${Colors.primaryRed}`
        : `inset 0px 0px 0px 1px ${Colors.rollingStone}`};
  }

  ${Responsive.mobile} {
    height: ${({ $size }) => ($size === 'normal' ? '26px' : '20px')};
    width: ${({ $size }) => ($size === 'normal' ? '26px' : '20px')};

    &::after {
      height: ${({ $size }) => ($size === 'normal' ? '26px' : '20px')};
      width: ${({ $size }) => ($size === 'normal' ? '26px' : '20px')};
      box-shadow: ${({ $active, $size }) =>
        $active === true && $size === 'normal'
          ? `inset 0px 0px 0px 9px ${Colors.primaryRed}`
          : $active === true && $size === 'small'
          ? `inset 0px 0px 0px 7px ${Colors.primaryRed}`
          : `inset 0px 0px 0px 1px ${Colors.rollingStone}`};
    }
  }
`
//
export default RadioButton
